import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type {
    ProductGroupPurchase,
    ProductConsignmentVo,
    Page,
    ProductGroupPurchaseQueryParams,
    ProductGroupPurchaseForm,
    ProductGroupPurchaseAuditForm,
    ServiceSpecialVo
} from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";

class GroupPurchaseService extends BaseService<
    ProductConsignmentVo,
    ProductConsignmentVo,
    ProductGroupPurchaseQueryParams,
    ProductGroupPurchaseForm
> {
    // 分页查询
    public async paging(params: ProductGroupPurchaseQueryParams): Promise<Page<ProductConsignmentVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }
    public async pagingSelector(params: {
        keyword: string;
        page: number;
        size: number;
    }): Promise<ProductGroupPurchase[]> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data.list;
    }

    /**
     * 下架商品
     * @param id
     */
    public async downShelf(id: number | string) {
        return this.service.put(`${this.path}/down-shelf/${id}`);
    }

    /**
     * 关闭商品
     * @param id
     * @param unActiveFileIds 要删除的文件id:
     */
    @confirmable("是否确认关闭")
    public async close(id: number | string, unActiveFileIds: number[] = []): Promise<void> {
        await this.service.put(`${this.path}/close/${id}`, {
            unActiveFileIds
        });
    }
    /**
     * 审核商品
     * @param id
     * @param form
     */
    public async audit(id: string, form: ProductGroupPurchaseAuditForm): Promise<void> {
        await this.service.put(`${this.path}/audit/${id}`, form);
    }

    public async getDetail(id: number | string): Promise<ProductConsignmentVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    /**
     * 修改权重值
     * @param params
     */
    public async updateWeight(params: { id: string; weight: number }): Promise<void> {
        await this.service.put(`${this.path}/weight/${params.id}`, params);
    }

    /**
     * 指派专员
     * @param id
     * @param handlerId
     */
    public async assign(id: string, handlerId: number): Promise<void> {
        await this.service.get(`${this.path}/assign/${id}/${handlerId}`);
    }
    /**
     * 获取专员列表
     * @param name
     */
    public async findServiceSpecials(name: string): Promise<ServiceSpecialVo[]> {
        const { data } = await this.service.get(`${this.path}/find/specials?name=${name}`);
        return data;
    }

    /**
     * 创建
     * @param form
     */
    @confirmable("是否提交")
    public async add(form: ProductGroupPurchaseForm): Promise<ProductConsignmentVo> {
        const { data } = await this.service.post(`${this.path}`, form);
        return data;
    }

    /**
     * 更新
     * @param id
     * @param form
     */
    @confirmable("是否提交")
    public async edit(id: string, form: ProductGroupPurchaseForm): Promise<ProductConsignmentVo> {
        const { data } = await this.service.put(`${this.path}/${id}`, form);
        return data;
    }

    /**
     * 新增保存
     */
    public async createSave(form: ProductGroupPurchaseForm): Promise<ProductConsignmentVo> {
        const { data } = await this.service.post(`${this.path}/create-save`, form);
        return data;
    }

    /**
     * 编辑保存
     */
    public async updateSave(id: string, form: ProductGroupPurchaseForm): Promise<ProductConsignmentVo> {
        const { data } = await this.service.post(`${this.path}/update-save/${id}`, form);
        return data;
    }
}
export const groupPurchaseService = new GroupPurchaseService("/admin/product-group-purchase", request.service);
